<style scoped>
</style>

<template>
    <div>
        <factory-order-list ref="orderList" :height="this.$tools.mainHeight() - 131" rights="'d,g,j'" :pageUrl="'factory/order/supplierPage'" :isRoot="true"></factory-order-list>
    </div>
</template>

<script>
import FactoryOrderList from "./Factory-order-list.vue";

export default {
    components: { FactoryOrderList },
};
</script>